import { formatBytes, getExtensionFromString } from './general';
import { ErrorCodes } from '../enums';
import {
    IArtifact,
    IFile,
    IFileResult,
    IFormattedMessageProps,
    IPickedResult,
    ITranslateKeyError,
} from '../interfaces';
import { mapFileUploadErrors } from './errors';

const MAX_ATTACHEMENTS_SIZE = 73400320;
//FIX to FREM-1997
const MAX_FILE_COUNT = 10;
/**
 * Format filename to Appendix name
 * @param file
 * @returns
 */
export const formatAttachmentName = (file: IFile): string => {
    return `${file.filename} (${getExtensionFromString(file.filename).toUpperCase()}, ${formatBytes(file.fileSize)})`;
};

export const retrieveErrorsFromFileUpload = (errors: ITranslateKeyError[]): IFormattedMessageProps[] => {
    if (errors && errors.length) {
        const filePickerErrors = errors
            .filter((error) => error.key in ErrorCodes)
            .map((fpError) => fpError.key as ErrorCodes);

        let newErrorList = errors
            .filter((error) => !(error.key in ErrorCodes))
            .map((error) => {
                return { id: error.key } as IFormattedMessageProps;
            });

        if (filePickerErrors.length > 0) {
            newErrorList = newErrorList.concat(mapFileUploadErrors(filePickerErrors));
        }

        return newErrorList.map((error) => ({ id: error.id, values: error.values }));
    } else {
        // Assume server returned a 400 http error because of bad content
        // a broken connection due to upload timeout
        return mapFileUploadErrors([ErrorCodes.FILE_BAD_CONTENT]);
    }
};

/**
 * Verify if files adhere to the specified constraints
 * this functions is extracted from write files and should be refactored even more
 * @param attachments
 * @param filePickResult
 * @returns
 */
export const validateFiles = (attachments: IArtifact[], filePickResult: IPickedResult): IFormattedMessageProps[] => {
    if (!attachments || !filePickResult) {
        return [];
    }
    //FIX to FREM-1997
    if (attachments.length == MAX_FILE_COUNT) {
        return [{ id: 'FILE_COUNTS_INVALID' }];
    }

    let totalFileSize = 0;
    Array.from(attachments).map((attachment) => {
        totalFileSize = totalFileSize + attachment.files[0].fileSize;
    });
    totalFileSize = totalFileSize + filePickResult.files[0].file.size;
    if (totalFileSize > MAX_ATTACHEMENTS_SIZE) {
        return [{ id: 'FILE_SIZE_INVALID', values: { size: 70 } }];
    }
    const hasDuplicates = attachments.some((artifact) =>
        artifact.files.some(
            (file) =>
                file.filename.replace(/\s+/g, '') ===
                filePickResult.files
                    .find((res) => res.file.name.replace(/\s+/g, '') === file.filename.replace(/\s+/g, ''))
                    ?.file?.name.replace(/\s+/g, '')
        )
    );

    if (hasDuplicates) {
        return [{ id: 'FILE_NAME_ALREADY_EXIST' }];
    }

    if (filePickResult.commonErrors && filePickResult.commonErrors.length > 0) {
        return filePickResult.commonErrors.map((error) => ({ id: error }));
    }

    if (filePickResult.files.some((file) => file.errors.length > 0)) {
        const filesWithErrors = filePickResult.files.filter((file) => file.errors.length > 0);
        let errorsInFiles: ErrorCodes[] = [];

        filesWithErrors.forEach((file: IFileResult) => {
            errorsInFiles = errorsInFiles.concat(file.errors.map((error) => error));
        });

        const errorDistinct = [...new Set(errorsInFiles)];
        const formattedErrors = mapFileUploadErrors(errorDistinct);
        return formattedErrors.map((error) => ({ id: error.id, values: error.values }));
    }

    return [];
};
